import { render, staticRenderFns } from "./resale-settings.page.vue?vue&type=template&id=28c9c9e0&scoped=true&"
import script from "./resale-settings.page.vue?vue&type=script&lang=js&"
export * from "./resale-settings.page.vue?vue&type=script&lang=js&"
import style0 from "./resale-settings.page.vue?vue&type=style&index=0&id=28c9c9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c9c9e0",
  null
  
)

export default component.exports